module.exports = __webpack_public_path__ + "img/rechnungen.c41583ec.png";